import { FEATURE_FLAG_NAMES, isFeatureEnabled, } from '@thoughtspot/feature-service';
import { isLLMGatewayV2Enabled } from '@thoughtspot/session-service';
export const getIsLLMGatewayEnabled = () => {
    return isLLMGatewayV2Enabled();
};
export const isLLMVisibilityEnabled = () => {
    return isFeatureEnabled(FEATURE_FLAG_NAMES.ENABLE_LLM_VISIBILITY);
};
//# sourceMappingURL=llm-gateway.util.js.map